import './Spinner.css';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'brand' | 'light' | 'dark';
  className?: string;
}

export function Spinner({ size = 'md', variant = 'brand', className = '' }: SpinnerProps) {
  return (
    <span 
      className={`app-spinner size-${size} variant-${variant} ${className}`}
      role="status"
      aria-label="Loading"
    />
  );
}
